module.exports = __webpack_public_path__ + "img/oil.c11a412f.png";